import { omit } from 'lodash';

import { i18n, t } from '@ezbobdev/ui-framework';

export const UserStateActions = {
  getUserState(property) {
    return this.state.userState[property];
  },

  resetUserState() {
    this.setState((state) => {
      return { ...state, userState: { authorities: ['ROLE_ANONYMOUS'] } };
    });
  },

  setUserState(property, value) {
    if (typeof property === 'object') {
      const object = property;
      this.setState((state) => {
        return { ...state, userState: { ...state.userState, ...object } };
      });
    } else {
      this.setState((state) => {
        return {
          ...state,
          userState: {
            ...state.userState,
            [property]: value,
          },
        };
      });
    }
  },

  removeUserState(property) {
    this.setState((prevState) => {
      return { ...prevState, userState: omit(prevState.userState, property) };
    });
  },

  setCurrentStep(currentStep) {
    const { actions } = this.state;

    actions.view.clearAlerts({ ignoreType: 'info' });
    this.setState(
      (state) => {
        return {
          ...state,
          userState: {
            ...state.userState,
            currentStep,
          },
        };
      },
      () => {
        const currentStep = actions.userState.getCurrentStepDetails();
        const stepDetails = actions.userState.getStepDetails(currentStep.stepName);
        document.title = stepDetails.title;
        window.scroll(0, 0);
      },
    );
  },
  setCurrentStepByName(name) {
    const { actions } = this.state;
    const steps = actions.settings.getUserConfigProp('steps');
    const stepId = steps.findIndex((step) => step.stepName === name);

    actions.userState.setCurrentStep(stepId);
    return name;
  },
  getCurrentStep() {
    return this.state.userState.currentStep;
  },

  getStepDetails(stepName) {
    const { actions } = this.state;
    if (!stepName) return {};
    const steps = actions.settings.getUserConfigProp('steps').map((step, id) => {
      return {
        ...step,
        id,
        title: i18n.exists(`steps.${id}.title`) ? t(`steps.${id}.title`) : '',
        label: i18n.exists(`steps.${id}.label`) ? t(`steps.${id}.label`) : '',
        loadingText: i18n.exists(`steps.${id}.loadingText`) ? t(`steps.${id}.loadingText`) : '',
        progressText: i18n.exists(`steps.${id}.progressText`) ? t(`steps.${id}.progressText`) : '',
        progressBarStep: step.progressBarStep,
      };
    });

    return steps.find((step) => step.stepName === stepName);
  },

  getCurrentStepDetails() {
    const stepsConfig = this.state.actions.settings.getUserConfigProp('steps');
    if (!stepsConfig) return {};
    const currentStep = this.state.actions.userState.getCurrentStep();
    const stepName = stepsConfig[currentStep] ? stepsConfig[currentStep].stepName : undefined;
    return this.state.actions.userState.getStepDetails(stepName);
  },

  getCurrentStepName() {
    const stepsConfig = this.state.actions.settings.getUserConfigProp('steps');
    if (!stepsConfig) return '';
    const currentStep = this.state.actions.userState.getCurrentStep();
    return stepsConfig[currentStep] ? stepsConfig[currentStep].stepName : '';
  },

  getCurrentStepTitle() {
    const currentStep = this.state.actions.userState.getCurrentStep();
    return i18n.exists(`steps.${currentStep}.title`) ? t(`steps.${currentStep}.title`) : '';
  },

  getCurrentStepLabel() {
    const currentStep = this.state.actions.userState.getCurrentStep();
    return i18n.exists(`steps.${currentStep}.label`) ? t(`steps.${currentStep}.label`) : '';
  },

  getPageDetails(pageName) {
    const { actions } = this.state;

    return {
      pageName,
      ...actions.settings.getPageRoute(pageName),
      title: i18n.exists(`pageRoutes.${pageName}`) ? t(`pageRoutes.${pageName}`) : undefined,
    };
  },

  getCurrentPageDetails() {
    const { actions } = this.state;
    const pageName = actions.view.getView('routeSettings.routePath');

    return {
      pageName,
      ...actions.settings.getPageRoute(pageName),
      title: i18n.exists(`pageRoutes.${pageName}`) ? t(`pageRoutes.${pageName}`) : undefined,
    };
  },
  getInitStep() {
    const { actions } = this.state;
    const defaultStepIndex = actions.settings.getUserConfigProp('steps').findIndex((step) => step.default);
    return defaultStepIndex && defaultStepIndex > -1 ? defaultStepIndex : 0;
  },
  isLoggedIn() {
    const { actions } = this.state;
    const userState = actions.userState.getUserState('userData') || {};
    return Boolean(userState['user_id']);
  },
  isCustomer() {
    const { actions } = this.state;
    const authorities = actions.userState.getUserState('authorities') || [];
    return authorities.includes('ROLE_CUSTOMER');
  },
  isBroker() {
    const { actions } = this.state;
    const authorities = actions.userState.getUserState('authorities') || [];
    return authorities.includes('ROLE_BROKER');
  },
};
